<template>
	<div class="payment">
		<!-- <h1>Payment {{ $route.params.id }}</h1> -->
		<div class="payment-top">
			<div class="header5">Method</div>
			<div class="header3">Payments</div>
			<div class="paragraph">
				A $1 charge will be charged to your credit card to confirm it is a valid card. No other charges will appear unless we are successful
				in lowering your property tax assessment. Garbur will not charge for our services until our appeal is complete and we have sent you a
				full report on the results of our appeal on your behalf.
			</div>
		</div>
		<div v-if="!paymentComplete" class="payment-side-sec">
			<div class="payment-type-options">
				<!-- <PaymentMethod
					paymentType="Paypal"
					text="Lorem ipsum dolor sit amet, consectetur adipiscing elit. "
					:changePayment="changePayment"
					:activePaymentMethod="activePaymentMethod"
				/> -->
				<PaymentMethod
					paymentType="Credit Card"
					text="Please enter your credit card information below."
					:changePayment="changePayment"
					:activePaymentMethod="activePaymentMethod"
				/>
			</div>
			<div class="amount-sec">
				Amount will charge from card: <span> ${{ this.casePayment }}</span>
			</div>
			<form class="payment-form" action="#">
				<div v-if="creditCardPayment" class="credit-card-sec">
					<div class="sharp input-box date-pick-sec">
						<div id="cardholderName" class="braintree-input" placeHolder="Card Holde Name"></div>
					</div>
					<div class="sharp input-box date-pick-sec">
						<div id="creditCardNumber" class="braintree-input"></div>
					</div>
					<div class="sharp input-box date-pick-sec">
						<div id="expireDate" class="braintree-input"></div>
					</div>
					<div class="sharp input-box date-pick-sec">
						<div id="cvv" class="braintree-input" placeHolder="Card Number"></div>
					</div>
					<div class="sharp input-box date-pick-sec">
						<div id="postalCode" class="braintree-input" placeHolder="Postal Code"></div>
					</div>
				</div>
				<!-- paypal setup -->
				<div v-else>Paypal info inputs</div>
				<div ref="paypal"></div>
				<!-- paypal setup -->
				<div class="alert alert-danger" v-if="error">
					{{ error }}
				</div>
				<br />

				<Button title="Pay Now!" :onClick="payWithCreditCard" />
			</form>
		</div>
		<!-- <div v-else>
			<div class="paragraph">
				Thank you for your payment, here is youre receipt and a download file, a copy was sent to your email to download whenever you want
			</div>
			<Button buttonType="outline" title="Download Receipt" />
		</div> -->
	</div>
</template>

<script>
// @ is an alias to /src
import Button from "@/components/ui/Button.vue";
import InputBox from "@/components/ui/InputBox.vue";
import PaymentMethod from "@/components/account/PaymentMethod.vue";
import localData from "@/store/utils/localdata";
// https://github.com/mariomka/vue-datetime
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import braintree from "braintree-web";
import api from "@/store/utils/api";

export default {
	name: "payment",
	title: "Payment",
	components: {
		Button,
		PaymentMethod,
		InputBox,
		datetime: Datetime,
	},
	data() {
		return {
			paymentComplete: false,
			creditCardPayment: true,
			picked: "",
			activePaymentMethod: "Credit Card",
			creditCardNumber: "",
			expireDate: "",
			cvv: "",
			hostedFieldInstance: false,
			nonce: "",
			error: "",
			casePayment: this.casePayment,
			deviceData: null,
		};
	},
	async mounted() {
		if (localData.getItem("activePaymentMethod")) {
			this.activePaymentMethod = localData.getItem("activePaymentMethod");
			this.casePayment = localData.getItem("casePayment");
		}

		const data = await api.post(`/api/v1/orders/${this.$route.params.id}/getPaymentDetails`);
		this.casePayment = data.price;
		// Breaintree stuff
		braintree.client
			.create({
				authorization: data.token,
			})
			.then((clientInstance) => {
				let options = {
					client: clientInstance,
					styles: {
						input: {
							"font-style": "normal",
							"font-weight": "300",
							"font-size": "16px",
							"line-height": "200%",
						},
					},
					fields: {
						number: {
							container: "#creditCardNumber",
							placeholder: "Card Number",
						},
						cvv: {
							container: "#cvv",
							placeholder: "Enter CVV",
						},
						expirationDate: {
							container: "#expireDate",
							placeholder: "Expire Date",
						},
						cardholderName: {
							container: "#cardholderName",
							placeholder: "Card Holder",
						},
						// streetAddress: {
						// 	container: "#streetAddress",
						// 	placeholder: "Street Address",
						// },
						postalCode: {
							container: "#postalCode",
							placeholder: "Postal Code",
						},
					},
				};
				braintree.dataCollector.create(
					{
						client: clientInstance,
						paypal: true,
					},
					function (err, dataCollectorInstance) {
						if (err) {
							// Handle error in creation of data collector
							return;
						}
						// At this point, you should access the dataCollectorInstance.deviceData value and provide it
						// to your server, e.g. by injecting it into your form as a hidden input.
						this.deviceData = dataCollectorInstance.deviceData;
					},
				);
				return braintree.hostedFields.create(options);
			})
			.then((hostedFieldInstance) => {
				// Use hostedFieldInstance to send data to Braintree
				this.hostedFieldInstance = hostedFieldInstance;
			})
			.catch((err) => {});
	},
	methods: {
		changePayment(payment) {
			this.activePaymentMethod = payment;
			localData.setItem("activePaymentMethod", this.activePaymentMethod);
		},
		payWithCreditCard() {
			if (this.hostedFieldInstance) {
				this.error = "";
				this.nonce = "";

				this.hostedFieldInstance
					.tokenize()
					.then(async (payload) => {
						console.log(payload);
						this.nonce = payload.nonce;
						await api.post(`/api/v1/orders/${this.$route.params.id}/checkout`, {
							nonce: payload.nonce,
							deviceData: this.deviceData,
						});
						this.paymentComplete = true;
						setTimeout(() => {
							this.$router.push(`/case/${this.$route.params.id}`);
						}, 1000);
					})
					.catch((err) => {
						console.error(err);
						this.error = err.message;
					});
			}

			// show thanks or payment conf/receipt
			// this.paymentComplete = true;
		},
	},
};
</script>

<style scoped lang="scss">
.payment {
	max-width: 1670px;
	text-align: left;
	padding: 0 60px;
	padding-top: 0px;
	padding-top: 120px;
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(430px, 1fr));
	grid-gap: 30px;
	.header5 {
		color: var(--accent);
		padding-bottom: 10px;
	}
	.header3 {
		font-style: normal;
		font-weight: normal;
		font-size: 36px;
		line-height: 36px;
		color: var(--dark-gray);
	}
	.paragraph {
		color: var(--black);
		opacity: 0.5;
		margin-top: 30px;
		margin-bottom: 30px;
	}
	.payment-form .button {
		width: 170px;
	}
	.credit-card-sec {
		margin-top: unset;
		margin-bottom: 45px;
	}
	// date picker
	.sharp.input-box.date-pick-sec {
		display: flex;
		flex-direction: row;
		align-items: center;
		margin-top: 15px;
		.vdatetime.date-input {
			position: relative;
			display: flex;
		}
		i.material-icons {
			margin-left: 10px;
		}
	}

	// after braintree
	.braintree-input {
		border: 1px solid #dbdee7;
		box-sizing: border-box;
		border-radius: 6px;
		height: 60px;
		font-family: Poppins;
		font-style: normal;
		font-weight: 300;
		font-size: 16px;
		line-height: 200%;
		color: var(--black);
		padding-left: 15px;
		width: 100%;
	}
	.braintree-input::placeholder {
		font-family: "Poppins";
		font-style: italic;
		color: var(--text);
	}
	.amount-sec {
		margin-top: 50px;
	}
	.alert.alert-danger {
		color: red;
	}
}
@media screen and (max-width: 414px) {
	.payment {
		padding: 4rem 1rem;
		grid-template-columns: repeat(auto-fit, minmax(345px, 1fr));
	}
}
</style>
